import { motion, AnimatePresence } from "framer-motion";
import { useDiscordStatus } from "@/hooks/useDiscordStatus";

const DiscordIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden>
    <path d="M20.3 4.4A19.8 19.8 0 0 0 15.4 3l-.2.4a18 18 0 0 1 4.4 1.9 15.2 15.2 0 0 0-15.2 0A18 18 0 0 1 8.8 3.4L8.6 3a19.8 19.8 0 0 0-4.9 1.4C.6 9 0 13.4.3 17.8a20 20 0 0 0 6 3l1.3-2a12.6 12.6 0 0 1-2-1l.5-.4a14.2 14.2 0 0 0 11.8 0l.5.4a12.6 12.6 0 0 1-2 1l1.3 2a20 20 0 0 0 6-3c.4-5.1-.7-9.5-3.4-13.4ZM8.7 15.1c-1.2 0-2.1-1.1-2.1-2.4s1-2.4 2.1-2.4 2.2 1.1 2.1 2.4c0 1.3-.9 2.4-2.1 2.4Zm6.6 0c-1.2 0-2.1-1.1-2.1-2.4s1-2.4 2.1-2.4 2.2 1.1 2.1 2.4c0 1.3-.9 2.4-2.1 2.4Z" />
  </svg>
);

export const DiscordButton = ({ href, testId, className = "" }) => {
  const d = useDiscordStatus();
  const ok = d?.ok;
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      data-testid={testId}
      className={`btn-glow inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/[0.04] pl-6 pr-2 py-2 text-sm font-semibold text-white backdrop-blur-md hover:bg-white/[0.08] ${className}`}
    >
      <DiscordIcon />
      Discord
      <AnimatePresence>
        {ok && (
          <motion.span
            initial={{ opacity: 0, x: -6, width: 0 }}
            animate={{ opacity: 1, x: 0, width: "auto" }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
            className="ml-1 inline-flex items-center gap-2 overflow-hidden whitespace-nowrap rounded-full bg-white/[0.08] px-3 py-1.5 font-mono text-[11px] font-medium"
            data-testid={`${testId}-count`}
          >
            <span className="inline-flex items-center gap-1.5 text-white">
              <span className="h-1.5 w-1.5 rounded-full bg-emerald-400" />
              {d.online}
            </span>
            <span className="text-white/45">{d.members} tag</span>
          </motion.span>
        )}
      </AnimatePresence>
      {!ok && <span className="w-2" />}
    </a>
  );
};
